const editorTabs = {
  init(el, binding) {
    const tabPrefix = binding.value && binding.value.prefix ? binding.value.prefix : 'editorUi';
    const tabsMenu = el.querySelectorAll(`.${tabPrefix}-tabsMenu`)[0];
    const tabItems = tabsMenu.querySelectorAll(`.${tabPrefix}-tab`);
    const tabsContent = el.querySelectorAll(`.${tabPrefix}-tabContent`)[0];
    const tabLayout = binding.arg;
    let borderColor = '#1a1b1f';
    let tabsIsLeft = false;
    let border;

    if (typeof binding.value !== typeof undefined && binding.value !== false) {
      borderColor = binding.value.borderColor;
    }

    // Viewport sizes
    const vueTablet = 'screen and (min-width:601px) and (max-width:992px)';
    const vueDesktop = 'screen and (min-width : 993px)';

    const resizeWindow = {
      resetTabs() {
        if (tabsIsLeft && (window.matchMedia(vueDesktop).matches ||
        window.matchMedia(vueTablet).matches)) {
          // Resets the tab content height for left tabs
          const leftContent = el.querySelectorAll(`.${tabPrefix}-tabContent-left`)[0];
          leftContent.style.minHeight = `${~~tabsMenu.offsetHeight + 25}px`;
        }
        tabItems.forEach((item) => {
          if (!item.classList.contains(`${tabPrefix}-activeTab`)) {
            item.classList.remove(`${tabPrefix}-mobile-li`);
          }
        });
      },
    };

    if (tabLayout.match(/left/gi)) {
      tabsIsLeft = true;
    }

    if (tabsIsLeft) {
      border = 'right';
      tabsMenu.classList.add(`${tabPrefix}-tabsMenu-left`);
      for (const tab of tabItems) {
        tab.classList.add(`${tabPrefix}-tab-left`);
      }
      tabsContent.classList.add(`${tabPrefix}-tabContent-left`);
      resizeWindow.resetTabs();
    } else {
      border = 'bottom';
    }

    // Set first tab active
    const firstTab = tabItems[0];
    firstTab.classList.add(`${tabPrefix}-activeTab`);
    firstTab.setAttribute('style', `border-${border}: 1px solid ${borderColor}`);
    firstTab
      .querySelectorAll(`.${tabPrefix}-tabLink`)[0]
      .classList.add(`${tabPrefix}-activeTabLink`);
    el
      .querySelectorAll(`.${tabPrefix}-tabContent > div`)[0]
      .classList.add(`${tabPrefix}-activeContent`);

    const clickTab = (tab) => {
      const tabLink = tab.querySelectorAll('a')[0];
      const contentID = tabLink.hash.split('#')[1];

      // Remove any active siblings
      [...tab.parentNode.children].forEach((child) => {
        child.classList.remove(`${tabPrefix}-activeTab`);
        child.setAttribute('style', `border-${border}: 1px solid transparent`);
        child.querySelectorAll('a')[0].classList.remove(`${tabPrefix}-activeTabLink`);
      });

      // Set clicked tab active
      tab.classList.add(`${tabPrefix}-activeTab`);
      tab.setAttribute('style', `border-${border}: 1px solid ${borderColor}`);
      tabLink.classList.add(`${tabPrefix}-activeTabLink`);

      // Set correct content section active
      [...tabsContent.children].forEach((content) => {
        content.classList.remove(`${tabPrefix}-activeContent`);
      });

      const liveContent = tabsContent.querySelectorAll(`.${contentID}`)[0];
      liveContent.classList.add(`${tabPrefix}-activeContent`);
    };

    tabItems.forEach(tab => tab.addEventListener('click', (e) => {
      e.preventDefault();
      clickTab(tab);
    }));
  },
};

export { editorTabs }; // eslint-disable-line



// WEBPACK FOOTER //
// ./src/directives/tabs.js